import React from 'react';
import { TextField, SelectField, MenuItem } from 'material-ui';
import moment from 'moment';
import R from 'ramda';
const convertToYY = ({ startDate, endDate }) => startDate && endDate ? `${moment.utc(startDate).format('D MMM YYYY')} - ${moment.utc(endDate).format('D MMM YYYY')}` : '';

const StepOneNameNdates = ({
  newGroupName,
  allContractPeriods,
  updateProps,
  selectContractYear,
  newGroupStartDate,
  newGroupEndDate,
}) => {
  return (<div>
    <label><b>Please enter a name for the group:</b></label> <span style={{ color: 'red' }}>* Required</span>
    <TextField
      style={{ display: 'block', width: '200px' }}
      hintText="Name the new group"
      defaultValue={newGroupName}
      onChange={(_, value) => updateProps({ newGroupName: value, editroupError: '' })}
    />
    <br/>
    <label style={{ marginBottom: '16px' }}><b>Please select a contracting period for the group:</b></label> <span style={{ color: 'red' }}>* Required</span>
    <br/>
    <SelectField
      autoWidth
      hintText="Click to select"
      iconStyle={{ fill: 'rgba(0, 0, 0, 0.75)' }}
      value={convertToYY({ startDate: newGroupStartDate, endDate: newGroupEndDate })}
    >
      {
        R.sort(R.ifElse(
                R.useWith(R.gt, [R.prop('endDate'), R.prop('endDate')]),
                  R.always(-1),
                R.always(1)
              ), allContractPeriods).map((obj, i) => (
          <MenuItem
            key={i}
            value={convertToYY(obj)}
            onTouchTap={() => selectContractYear(obj)}
            primaryText={convertToYY(obj)}
          />))
      }
    </SelectField>
  </div>)
};

export default StepOneNameNdates;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-group/step-one-name-dates.jsx